import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { RNTOtrasSolicitudEntry } from "src/app/shared/entrys/RNTOtrasSolicitudEntry.entry";

@Injectable({
  providedIn: "root",
})
export class InformacionService
  implements RequestCRUD<RNTOtrasSolicitudEntry, ResponseServiceModel>
{
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError("informacion");
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  update(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  create(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  delete(entry: RNTOtrasSolicitudEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  descargarDocumento(entry: any): Observable<Blob> {
    return this.http
      .post<Blob>(
        `${this.API_URL}/DocumentoDetalleSolicitud/DescargarDocumento`,
        entry
      )
      .pipe(retry(2));
  }

  getInFPagoFontur(entry:any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Fontur/GetInformacionPagoFontur`,
        entry
      )
      .pipe(retry(2));
  }
}
